import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SupplierCodeOfConduct from "@/pages/SupplierCodeOfConduct";

export const Route = createFileRoute("/es/codigo-de-conducta-del-proveedor")({
  head: () => buildRouteHead("/es/codigo-de-conducta-del-proveedor"),
  component: SupplierCodeOfConduct,
});

